<template>
    <div class="container">
        <menus></menus>
        <!-- <img class="tops" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/imgs/kv.png" alt=""> -->
        <!-- <div class="title">{{ $t('login.title') }}</div> -->
        <div class="main">
            <div class="mainLogin">
                <input type="hidden" name="openid" id="openid" value="">
                <input type="hidden" name="nickname" id="nickname" value="">
                <input type="hidden" name="headimgurl" id="headimgurl" value="">
                <div class="loginTable">
                    <div class="input">
                        <input type="text" name="userMobile" ref="cellphone" id="userMobile" maxlength="11" class="in-phone" v-model='cellphone'  :placeholder="$t('login.phone')">
                    </div>
                    <div class="isInter">
                        <p><input type="checkbox" name="Country" id="Country" v-model="is_country" @click='img_code'>
                            <label for="Country">{{ $t('login.country') }}</label>
                        </p>
                    </div>
                    <div class="tr">
                        <input type="text" name="yzcode" id="yzcode" maxlength="6" class="in-phone"  v-model='code' :placeholder="$t('login.code')">
                        <button id="yzmhq" class="btnCode" v-bind:disabled="showCount" v-show='!is_country' @click='getCode' :class="$i18n.locale == 'jp' ? 'country' : ''">{{ count }} <span v-show='count > 0'>s</span></button>
                        <canvas v-show='is_country' id="canvas" width="120" height="40" @click="img_code"></canvas>
                    </div>
                </div>
                <button id="logFormBut" @click='submit' class="btnLogin">{{ $t('login.loginBtn') }}</button>
            </div>
        </div>
        <div class="toast" v-show="toastShow">
            {{ toastText }}
        </div>
        <!-- <div class="footer">&copy;2020</div> -->
    </div>
</template>

<script>
import axios from 'axios'
import menus from "../components/menu.vue"
export default {
    components: {
        menus
    },
    name: 'loginView',
    data() {
        return {
            is_country: false,
            toastText: '',
            toastShow: false,
            cellphone: "",
            reg: /^1[3456789]\d{9}$/,
            code: "",
            count: this.$t('login.getCode'),
            showCount: false,
            timer: null,
            reg: /^1[3456789]\d{9}$/,
            disable: false,
            getText: this.$t('login.getCode'),
            code_click: true,
            click: true,
            openid: localStorage.getItem("nissan2023_meeting_openid"),
            photo: localStorage.getItem("nissan2023_meeting_cover"),
            nickname: localStorage.getItem("nissan2023_meeting_name"),
            show_num: [],
        }
    },
    created() {
        let lang = localStorage.getItem("nissan2023_meeting_lang"), that = this;;
        if (lang == "" || lang == null) {
            that.$i18n.locale = 'zh';
        } else {
            that.$i18n.locale = lang;
            that.count = that.$t('login.getCode');
        }
        document.title = that.$t('title');
        //_hmt.push(['_trackPageview', '/login']);

    },
    watch: {
        is_country() {
            let that = this;
            that.code = "";
        }
    },
    methods: {
        img_code() {
            this.draw(this.show_num);
        },
        getCode() {
            let that = this, data = new FormData();
            if (that.code_click) {
                console.log(1);
                that.code_click = false;
                if (that.cellphone == "") {
                    console.log(2);
                    that.toast(that.$t('tips.phone'));
                    that.$refs.cellphone.focus();
                } else if (!that.is_country && !that.reg.test(that.cellphone)) {
                    console.log(3);
                    that.toast(that.$t('tips.phone_err'))
                    that.$refs.cellphone.focus();
                } else {
                    console.log(4);
                    that.disable = true;
                    data.append("phone", that.cellphone)
                    that.axios.post('message', data).then(res => {
                        if (res.data.code == 200) {
                            console.log(5);
                            that.toastText = that.$t('tips.code_success')
                            that.toastShow = true;
                            setTimeout(function () {
                                that.toastShow = false
                            }, 1500)
                            that.time();
                        } else if (res.data.code == 1104) {//不在白名单
                            console.log(6);
                            that.toast(that.$t('tips.l_tips1'))
                        }
                    }).catch(err => {
                        console.error(err);
                    })
                }
            }
        },
        time() {
            let that = this;
            const time = 60;
            if (!that.timer) {
                that.count = time;
                that.timer = setInterval(() => {
                    if (that.count > 1 && that.count <= 60) {
                        that.count--;
                    } else {
                        that.count = that.$t('login.getCode');
                        clearInterval(that.timer);
                        that.timer = null;
                        that.code_click = that.disable = true;
                    }
                }, 1000)
            }
        },
        submit() {
            let that = this,
                data = new FormData();
            if (that.click) {
                that.click = false;
                if (that.cellphone == "") {
                    that.toast(that.$t('tips.phone'));
                    that.$refs.cellphone.focus();
                    return false
                } else if (!that.is_country && !that.reg.test(that.cellphone)) {
                    that.toast(that.$t('tips.phone_err'))
                    that.$refs.cellphone.focus();
                    return false
                } else if (that.code == "") {
                    that.toast(that.$t('tips.code'))
                    return false;
                } else if (!that.is_country && that.code.length != 6) {
                    that.toast(that.$t('tips.code_err'))
                    return false;
                } else if (that.is_country && that.code.toLowerCase() != that.show_num.join("")) {
                    that.toast(that.$t('tips.code_err'))
                    return false;
                }
                if (that.is_country) {
                    data.append("yzm", '012349')
                } else {
                    data.append("yzm", that.code)
                }
                data.append("phone", that.cellphone)
                // data.append("openid", that.openid)
                // data.append("nickname", that.nickname)
                // data.append("photo", that.photo)
                that.axios.post('login', data).then(res => {
                    if (res.data.code == 200) {
                        that.toast(that.$t('tips.loginSuccess'))
                        localStorage.setItem("nissan2023_meeting_user_userType", res.data.userType)
                        localStorage.setItem("nissan2023_meeting_uuid", res.data.uuid)
                        localStorage.setItem("nissan2023_meeting_mobile", that.cellphone)
                        setTimeout(() => {
                            that.$router.replace("/menu")
                        }, 1000)
                    } else if (res.data.code == 1103) {//验证码有误
                        that.toast(that.$t('tips.l_tips2'))
                    } else if (res.data.code == 1104) {//不在白名单
                        that.toast(that.$t('tips.l_tips1'))
                    }
                }).catch(err => {
                    console.error(err);
                })
            }


        },
        toast(str) {
            let that = this
            that.toastText = str
            that.toastShow = true
            setTimeout(function () {
                that.toastShow = false
                that.click = that.code_click = true;
            }, 1500)
        },
        draw(show_num) {
            var canvas_width = document.getElementById("canvas").width;
            var canvas_height = document.getElementById("canvas").height;
            var canvas = document.getElementById("canvas");//获取到canvas的对象，演员
            var context = canvas.getContext("2d");//获取到canvas画图的环境，演员表演的舞台
            canvas.width = canvas_width;
            canvas.height = canvas_height;
            var sCode = "A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0";
            var aCode = sCode.split(",");
            var aLength = aCode.length;//获取到数组的长度

            for (var i = 0; i <= 3; i++) {
                var j = Math.floor(Math.random() * aLength);//获取到随机的索引值
                var deg = Math.random() * 30 * Math.PI / 180;//产生0~30之间的随机弧度
                var txt = aCode[j];//得到随机的一个内容
                show_num[i] = txt.toLowerCase();
                var x = 10 + i * 20;//文字在canvas上的x坐标
                var y = 20 + Math.random() * 8;//文字在canvas上的y坐标
                context.font = "bold 23px 微软雅黑";

                context.translate(x, y);
                context.rotate(deg);

                context.fillStyle = this.randomColor();
                context.fillText(txt, 0, 0);

                context.rotate(-deg);
                context.translate(-x, -y);
            }
            for (var i = 0; i <= 5; i++) { //验证码上显示线条
                context.strokeStyle = this.randomColor();
                context.beginPath();
                context.moveTo(Math.random() * canvas_width, Math.random() * canvas_height);
                context.lineTo(Math.random() * canvas_width, Math.random() * canvas_height);
                context.stroke();
            }
            for (var i = 0; i <= 30; i++) { //验证码上显示小点
                context.strokeStyle = this.randomColor();
                context.beginPath();
                var x = Math.random() * canvas_width;
                var y = Math.random() * canvas_height;
                context.moveTo(x, y);
                context.lineTo(x + 1, y + 1);
                context.stroke();
            }
        },
        randomColor() {//得到随机的颜色值
            var r = Math.floor(Math.random() * 256);
            var g = Math.floor(Math.random() * 256);
            var b = Math.floor(Math.random() * 256);
            return "rgb(" + r + "," + g + "," + b + ")";
        }
    }
}
</script>
<style scoped>
.title {
    width: 5.95rem;
    margin: 0 auto .42rem;
    height: 0.8rem;
    background: #c61533;
    font-size: .35rem;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
}

.input {
    margin-bottom: .3rem;
}

.isInter {
    margin-bottom: .3rem;
}

.tr {
    display: flex;
    margin-bottom: .6rem;
}

.country {
    font-size: .2rem;
    line-height: .6rem;
    margin-left: .2rem;
}


#canvas {
    height: .6rem;
}

#yzcode {
    flex: 1;
    width: 100%;
}

.btnCode,
#canvas {
    height: 100%;
    width: 2.3rem;
    margin-left: .2rem;
}

.main {
    width: 100%;
    padding: 0 .78rem 1rem;
}

.isInter p {
    display: flex;
    align-items: center;
}

#canvas {
    border: 1px solid rgba(23, 171, 162, .7);
    border-radius: .1rem;
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue